<template>
  <div>
    <div class="pb-10 d-flex align-center justify-space-between">
      <div>
        <h2>Bitacora de agenciamiento</h2>
        <span style="font-size: 13px; color: gray">
          Registra los accesos y usos de infraestructura de las embarcaciones
        </span>
      </div>

      <v-btn color="black" @click="dialogBitacora = true" dark small
        >Nuevo registro</v-btn
      >
    </div>
    <v-dialog v-model="dialogBitacora" fullscreen>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogBitacora = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Registrar acceso</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-container>
          <v-row>
            <v-col cols="5">
              <span style="font-size: 13px; color: gray; margin-bottom: 10px"
                >Ingresa los datos requeridos</span
              >
              <v-container>
                <v-row dense>
                  <v-col class="" cols="12" sm="12">
                    <v-select
                      :items="solicitudes"
                      dense
                      :rules="[rules.required]"
                      style="font-size: 13px"
                      v-model="solicitud"
                      @input="mostrarSolicitudFolio"
                      label="Solicitudes de acceso"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col class="" cols="6" sm="6">
                    <v-text-field
                      type="datetime-local"
                      dense
                      v-if="events.length == 1 || primer_atraque"
                      v-model="atraque"
                      style="font-size: 13px"
                      :max="
                        new Date(Date.now())
                          .toISOString()
                          .slice(0, 16)
                      "
                      label="Atraque"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      type="date"
                      dense
                      v-else
                      :max="
                        new Date(Date.now())
                          .toISOString()
                          .substr(0, 10)
                      "
                      v-model="fecha"
                      style="font-size: 13px"
                      label="Fecha de captura"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col class="" cols="6" sm="6">
                    <div
                      v-if="!huboDesatraque"
                      class="d-flex justify-center align-center"
                      style="height: 56px"
                    >
                      <v-checkbox v-model="huboDesatraque">
                        <template v-slot:label>
                          <span style="font-size: 13px">¿Hubo desatraque?</span>
                        </template>
                      </v-checkbox>
                    </div>
                    <div v-if="huboDesatraque" class="d-flex align-center">
                      <v-text-field
                        type="datetime-local"
                        dense
                        :max="
                          new Date(Date.now())
                            .toISOString()
                            .slice(0, 16)
                        "
                        v-model="desatraque"
                        label="Desatraque"
                        style="font-size: 13px"
                        outlined
                        hide-details
                        class="mr-2"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col class="" cols="6" sm="6">
                    <v-text-field
                      type="number"
                      v-model="embarque_pax"
                      dense
                      label="Embarque PAX"
                      outlined
                      style="font-size: 13px"
                    ></v-text-field>
                  </v-col>
                  <v-col class="" cols="6" sm="6">
                    <v-text-field
                      type="number"
                      v-model="desembarque_pax"
                      dense
                      label="Desembarque PAX"
                      style="font-size: 13px"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col class="" cols="6" sm="6">
                    <v-text-field
                      type="number"
                      dense
                      v-model="embarque_mat"
                      label="Embarque Mat"
                      style="font-size: 13px"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col class="" cols="6" sm="6">
                    <v-text-field
                      type="number"
                      dense
                      style="font-size: 13px"
                      v-model="desembarque_mat"
                      label="Desembarque Mat"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col class="" cols="6" sm="6">
                    <v-text-field
                      type="number"
                      dense
                      style="font-size: 13px"
                      v-model="movimient_int"
                      label="Movimientos internos"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col class="" cols="12" sm="12">
                    <v-switch v-model="atraq_desat" label="Amarre/Desamarre"></v-switch>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-btn
                      v-if="!editMode"
                      color="primary"
                      @click="insertarBitacora"
                      dark
                      :loading="loading"
                      block
                      >Registrar acceso</v-btn
                    >
                    <v-btn
                      @click="updateBitacora"
                      v-if="editMode"
                      color="primary"
                      dark
                      :loading="loading"
                      block
                      >Actualizar acceso</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-btn
                      v-if="editMode"
                      color="secondary"
                      @click="cancelarEdicion"
                      dark
                      block
                      >Cancelar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col cols="7">
              <v-row class="fill-height">
                <v-col>
                  <v-sheet height="64">
                    <v-toolbar flat>
                      <v-btn
                        outlined
                        class="mr-4"
                        color="grey darken-2"
                        @click="setToday"
                      >
                        Hoy
                      </v-btn>
                      <v-btn fab text small color="grey darken-2" @click="prev">
                        <v-icon small> chevron_left </v-icon>
                      </v-btn>
                      <v-btn fab text small color="grey darken-2" @click="next">
                        <v-icon small> chevron_right </v-icon>
                      </v-btn>
                      <v-toolbar-title style="font-size: 14px" v-if="$refs.calendar">
                        {{ $refs.calendar.title }}
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-menu bottom right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                            <span>{{ typeToLabel[type] }}</span>
                            <v-icon right> arrow_drop_down </v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="type = 'day'">
                            <v-list-item-title>Día</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="type = 'week'">
                            <v-list-item-title>Semana</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="type = 'month'">
                            <v-list-item-title>Mes</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="type = '4day'">
                            <v-list-item-title>4 dias</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-toolbar>
                  </v-sheet>
                  <v-sheet height="600">
                    <v-calendar
                      ref="calendar"
                      v-model="focus"
                      color="primary"
                      :events="events"
                      :event-color="getEventColor"
                      :type="type"
                      @click:event="showEvent"
                    ></v-calendar>
                    <v-menu
                      v-model="selectedOpen"
                      :close-on-content-click="false"
                      :activator="selectedElement"
                      offset-x
                    >
                      <v-card class="elevation-3 rounded-lg" min-width="550px">
                        <!-- Header -->
                        <v-toolbar
                          :color="selectedEvent.color"
                          dark
                          flat
                          dense
                          class="rounded-t-lg"
                        >
                          <v-toolbar-title class="font-weight-bold text-h6">
                            {{ selectedEvent.name }}
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <div
                            v-if="selectedEvent.detail && selectedEvent.color === 'blue'"
                          >
                            <v-btn
                              v-if="usuario_log.rol == 'root'"
                              icon
                              @click="iniciarEdicion(selectedEvent)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="usuario_log.rol == 'root'"
                              icon
                              @click="confirmDelete(selectedEvent)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </div>
                        </v-toolbar>

                        <!-- Azul - Detalles Financieros -->
                        <v-card
                          v-if="selectedEvent.detail && selectedEvent.color === 'blue'"
                          flat
                        >
                          <v-divider></v-divider>

                          <v-card-text>
                            <v-row dense>
                              <v-col
                                cols="12"
                                sm="6"
                                v-for="(value, key) in {
                                  Estadía: selectedEvent.detail.estadia + ' hrs',
                                  'Cuota de arribo': formatCurrency(
                                    selectedEvent.detail.cuota_arribo
                                  ),
                                  'Cuota de atraque': formatCurrency(
                                    selectedEvent.detail.cuota_atraque
                                  ),
                                  'Amarre / Desamarre': formatCurrency(
                                    selectedEvent.detail.tarifa_amarre_desamarre
                                  ),
                                  'Tarifa pasajeros': formatCurrency(
                                    selectedEvent.detail.tarifa_pasajeros
                                  ),
                                  'Tarifa muellaje': formatCurrency(
                                    selectedEvent.detail.muellaje
                                  ),
                                  'Mov. internos': formatCurrency(
                                    selectedEvent.detail.tarifa_mov_intern
                                  ),
                                  Subtotal: formatCurrency(selectedEvent.detail.subtotal),
                                }"
                                :key="key"
                              >
                                <div class="grey--text text--darken-1 text-caption">
                                  {{ key }}
                                </div>
                                <div class="text-body-2 font-weight-bold">
                                  {{ value }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="secondary" text @click="selectedOpen = false">
                              Salir
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        <!-- Gris - Tentativo -->
                        <v-card
                          v-else-if="
                            selectedEvent.detail && selectedEvent.color === 'grey'
                          "
                          flat
                        >
                          <v-card-text>
                            <div class="text-caption grey--text mb-3">
                              El rango de fecha mostrado es un tentativo del tiempo que la
                              embarcación permanecerá en el muelle, de acuerdo a la
                              solicitud de la agencia.
                            </div>
                            <v-row dense>
                              <v-col cols="6">
                                <div class="grey--text text--darken-1 text-caption">
                                  ETA
                                </div>
                                <div class="text-body-2 font-weight-bold">
                                  {{ selectedEvent.detail.eta }}
                                </div>
                              </v-col>
                              <v-col cols="6">
                                <div class="grey--text text--darken-1 text-caption">
                                  ETD
                                </div>
                                <div class="text-body-2 font-weight-bold">
                                  {{ selectedEvent.detail.etd }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="secondary" text @click="selectedOpen = false">
                              Salir
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        <!-- Naranja - Atraque -->
                        <v-card
                          v-else-if="
                            selectedEvent.detail && selectedEvent.color === 'orange'
                          "
                          flat
                        >
                          <v-card-text>
                            <div class="text-caption grey--text mb-3">
                              El rango de fecha mostrado es tentativo del tiempo que la
                              embarcación permanecerá en el muelle, de acuerdo a la
                              solicitud de la agencia.
                            </div>
                            <v-row dense>
                              <v-col cols="6">
                                <div class="grey--text text--darken-1 text-caption">
                                  Atraque
                                </div>
                                <div class="text-body-2 font-weight-bold">
                                  {{ selectedEvent.detail.atraque }}
                                </div>
                              </v-col>
                              <v-col cols="6">
                                <div class="grey--text text--darken-1 text-caption">
                                  ETD
                                </div>
                                <div class="text-body-2 font-weight-bold">
                                  {{ selectedEvent.detail.etd }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="secondary" text @click="selectedOpen = false">
                              Salir
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        <!-- Rojo - Error / Faltante -->
                        <v-card
                          v-else-if="
                            selectedEvent.detail && selectedEvent.color === 'red'
                          "
                          flat
                        >
                          <v-card-text>
                            <div class="text-caption grey--text">
                              No se han encontrado registros para el día faltante, pero
                              existen registros previos. Favor de ingresar la estadía de
                              la embarcación para ese día.
                            </div>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="secondary" text @click="selectedOpen = false">
                              Salir
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        <!-- Verde - Confirmación -->
                        <v-card
                          v-else-if="
                            selectedEvent.detail && selectedEvent.color === 'green'
                          "
                          flat
                        >
                          <v-card-text>
                            <v-row dense>
                              <v-col cols="6">
                                <div class="grey--text text--darken-1 text-caption">
                                  Atraque
                                </div>
                                <div class="text-body-2 font-weight-bold">
                                  {{ selectedEvent.detail.atraque }}
                                </div>
                              </v-col>
                              <v-col cols="6">
                                <div class="grey--text text--darken-1 text-caption">
                                  Desatraque
                                </div>
                                <div class="text-body-2 font-weight-bold">
                                  {{ selectedEvent.detail.desatraque }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                    </v-menu>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-layout>
      <v-flex>
        <v-row>
          <v-col cols="12">
            <div class="input-filter">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" color="primary" class="mb-2">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item dense @click="showFilterEmbarcacion = true">
                    <v-list-item-title>
                      <span class="texto">Embarcación</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item dense @click="showFilterAgencia = true">
                    <v-list-item-title>
                      <span class="texto">Agencia</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="text-center"></div>
              <div v-if="arr.length == 0" class="filter-label">
                <span>Ningun filtro seleccionado...</span>
              </div>
              <div v-else class="filter-chips">
                <v-chip
                  class="ml-2"
                  v-for="(item, index) in arr"
                  :key="index"
                  close
                  close-icon="cancel"
                  @click:close="eliminarFiltro(index)"
                  color="primary"
                  small
                >
                  {{ item.label }}
                </v-chip>
              </div>

              <v-dialog
                v-model="showFilterFecha"
                transition="dialog-bottom-transition"
                max-width="350"
              >
                <v-card>
                  <v-toolbar color="primary" dark>Busqueda por Fecha</v-toolbar>
                  <v-card-text class="mt-10">
                    <v-text-field
                      type="date"
                      outlined
                      dense
                      label="Ingrese la fecha que decea filtrar"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn text @click="filtroLabelPush('fecha')">Aplicar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex flex-column page-fill">
            <div class="flex-grow-1 overflow-auto">
              <v-simple-table class="rounded-table mt-3" style="" dense>
                <thead class="rounded-table" style="background-color: rgb(128, 0, 32)">
                  <tr style="border-radius: 15px">
                    <th class="white--text">Folio</th>
                    <th class="white--text">Embarcación</th>
                    <th class="white--text">Agencia</th>
                    <th class="white--text">Muelle</th>
                    <th class="white--text">Atraque</th>
                    <th class="white--text">Desatraque</th>
                    <th class="white--text">Embarque PX</th>
                    <th class="white--text">Desembarque PX</th>
                  </tr>
                </thead>

                <tbody style="">
                  <tr
                    v-for="(item, index) in bitacora"
                    :key="index"
                    @click="abrirDetalle(item)"
                    class="clickable-row"
                  >
                    <td style="font-size: 12px; font-weight: bold">
                      {{
                        formatFolio(
                          item.folio_solicitud.folio_solicitud,
                          item.folio_solicitud.muelle,
                          item.folio_solicitud.createdAt
                        )
                      }}
                    </td>
                    <td style="font-size: 12px; color: gray; font-weight: bold">
                      {{ item.folio_solicitud.embarcacion.nombre }}
                    </td>
                    <td style="font-size: 12px; color: gray; font-weight: bold">
                      {{ item.folio_solicitud.agencia.nombre }}
                    </td>
                    <td style="font-size: 12px; color: gray; font-weight: bold">
                      {{ item.folio_solicitud.muelle }}
                    </td>
                    <td style="font-size: 12px; color: gray; font-weight: bold">
                      {{ formatDate(item.atraque) }}
                    </td>
                    <td style="font-size: 12px; color: gray; font-weight: bold">
                      {{
                        item.desatraque
                          ? formatDate(item.desatraque)
                          : "Desatraque no registrado"
                      }}
                    </td>
                    <td style="font-size: 12px; color: gray; font-weight: bold">
                      {{ item.embarque_px }}
                    </td>
                    <td style="font-size: 12px; color: gray; font-weight: bold">
                      {{ item.desembarque_px }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
            <v-row class="mt-3 align-center">
              <v-col cols="12" sm="6">
                <v-select
                  :items="[10, 25, 50]"
                  v-model="limit"
                  dense
                  outlined
                  hide-details
                  label="Registros por página"
                  style="max-width: 220px"
                />
              </v-col>
              <v-col cols="12" sm="6" class="d-flex justify-end">
                <v-pagination v-model="page" :length="totalPages" total-visible="7" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-dialog
          v-model="showFilterEmbarcacion"
          transition="dialog-bottom-transition"
          max-width="350"
        >
          <v-card>
            <v-toolbar color="primary" dark>Busqueda por Embarcación</v-toolbar>
            <v-card-text class="mt-10">
              <v-autocomplete
                return-object
                v-model="embarcacion_filter"
                outlined
                :items="embarcaciones"
                dense
                label="Ingrese la embarcación"
              ></v-autocomplete>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="filtroLabelPush('embarcacion')">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showDetalleDialog" max-width="800">
          <v-card>
            <v-toolbar color="blue" dark>
              <v-toolbar-title class="font-weight-bold text-h6"
                >Detalles Financieros</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn icon @click="showDetalleDialog = false"
                ><v-icon>close</v-icon></v-btn
              >
            </v-toolbar>
            <v-card-text class="pt-6" v-if="detalleBitacora">
              <v-row class="mb-4" dense>
                <v-col cols="12" sm="6">
                  <div class="grey--text text--darken-1 text-caption">Folio</div>
                  <div class="text-body-2 font-weight-bold">
                    SU-{{ detalleBitacora.folio_solicitud.folio_solicitud }}
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="grey--text text--darken-1 text-caption">Embarcación</div>
                  <div class="text-body-2 font-weight-bold">
                    {{ detalleBitacora.folio_solicitud.embarcacion.nombre }}
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="grey--text text--darken-1 text-caption">Agencia</div>
                  <div class="text-body-2 font-weight-bold">
                    {{ detalleBitacora.folio_solicitud.agencia.nombre }}
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="grey--text text--darken-1 text-caption">Muelle</div>
                  <div class="text-body-2 font-weight-bold">
                    {{ detalleBitacora.folio_solicitud.muelle }}
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="grey--text text--darken-1 text-caption">Atraque</div>
                  <div class="text-body-2 font-weight-bold">
                    {{ formatDate(detalleBitacora.atraque) }}
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="grey--text text--darken-1 text-caption">Desatraque</div>
                  <div class="text-body-2 font-weight-bold">
                    {{
                      detalleBitacora.desatraque
                        ? formatDate(detalleBitacora.desatraque)
                        : "Desatraque no registrado"
                    }}
                  </div>
                </v-col>
              </v-row>

              <v-divider class="my-2"></v-divider>

              <v-card flat>
                <v-card-text>
                  <v-row dense>
                    <v-col
                      cols="12"
                      sm="6"
                      v-for="(value, key) in {
                        Estadía:
                          detalleBitacora.detail && detalleBitacora.detail.estadia
                            ? detalleBitacora.detail.estadia + ' hrs'
                            : '0 hrs',
                        'Cuota de arribo': formatCurrency(
                          detalleBitacora.detail && detalleBitacora.detail.cuota_arribo
                        ),
                        'Cuota de atraque': formatCurrency(
                          detalleBitacora.detail &&
                            (detalleBitacora.detail.cuota_atraque ||
                              detalleBitacora.detail.tarifa_atraque)
                        ),
                        'Amarre / Desamarre': formatCurrency(
                          detalleBitacora.detail &&
                            detalleBitacora.detail.tarifa_amarre_desamarre
                        ),
                        'Tarifa pasajeros': formatCurrency(
                          detalleBitacora.detail &&
                            detalleBitacora.detail.tarifa_pasajeros
                        ),
                        'Tarifa muellaje': formatCurrency(
                          detalleBitacora.detail && detalleBitacora.detail.muellaje
                        ),
                        'Mov. internos': formatCurrency(
                          detalleBitacora.detail &&
                            detalleBitacora.detail.tarifa_mov_intern
                        ),
                        Subtotal: formatCurrency(
                          detalleBitacora.detail && detalleBitacora.detail.subtotal
                        ),
                      }"
                      :key="key"
                    >
                      <div class="grey--text text--darken-1 text-caption">{{ key }}</div>
                      <div class="text-body-2 font-weight-bold">{{ value }}</div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="showDetalleDialog = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="showFilterAgencia"
          transition="dialog-bottom-transition"
          max-width="350"
        >
          <v-card>
            <v-toolbar color="primary" dark>Busqueda por Agencia</v-toolbar>
            <v-card-text class="mt-10">
              <v-autocomplete
                return-object
                v-model="agencia_filter"
                outlined
                :items="agencias"
                dense
                label="Ingrese la agencia"
              ></v-autocomplete>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="filtroLabelPush('agencia')">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >¿Estás seguro de que quieres eliminar este registro?</v-card-title
        >
        <v-card-text>Esta acción no se puede deshacer.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm" :loading="loading"
            >Aceptar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  getFoliosSolicitudes,
  insertBitacoraEmbarcacion,
  updateBitacoraEmbarcacion,
  deleteBitacoraEmbarcacion,
  listAccesoFolio,
  listEmbarcacionesBitacora,
  listAgenciasBitacora,
  listBitacora,
} from "../../api/endpoints";
import LoadingOverlay from "../components/Loading.vue";
import MaterialCard from "../components/MaterialCard.vue";
export default {
  components: {
    LoadingOverlay,
    MaterialCard,
  },
  data() {
    return {
      _id: "",
      showFilterFolio: false,
      loading: true,
      solicitudes: [],
      editMode: false,
      dialogDelete: false,
      itemToDelete: null,
      showFilterFecha: false,
      showFilterEmbarcacion: false,
      embarcacion_filter: null,
      showFilterAgencia: false,
      agencia_filter: null,

      // Dialog detalle bitácora
      showDetalleDialog: false,
      detalleBitacora: null,

      //  solicitudes: ["Flecha de Oro SU-23", "Flecha de Oro SU-23", "Arrow 1 SU-39"],
      dialogBitacora: false,
      headers: [
        { text: "Folio", value: "folio_solicitud.folio_solicitud" },
        { text: "Embarcación", value: "folio_solicitud.embarcacion.nombre" },
        { text: "Agencia", value: "folio_solicitud.agencia.nombre" },
        { text: "Atraque", value: "atraque" },
        { text: "Desatraque", value: "desatraque" },
        { text: "Amarre/Desamarre", value: "atraque_desatraque" },
        { text: "Movimientos internos", value: "movimiento_interno" },
        { text: "Embarque (Ton)", value: "estado" },
        { text: "Desembarque (Ton)", value: "estado" },
        { text: "Opciones", value: "opciones", align: "right" },
      ],
      arr: [],
      solicitud: "",
      atraque: "",
      fecha: "",
      desatraque: "",
      huboDesatraque: false,
      embarque_pax: 0,
      desembarque_pax: 0,
      bitacora: [],
      embarcaciones: [],
      agencias: [],
      embarque_mat: 0,
      desembarque_mat: 0,
      atraq_desat: false,
      movimient_int: 0,
      existAtraque: false,
      primer_atraque: null,
      // Paginación Bitácora
      page: 1,
      limit: 10,
      total: 0,
      totalPagesApi: 0,
      //CALENDARIO
      focus: "",
      type: "month",
      typeToLabel: {
        month: "Mes",
        week: "Semana",
        day: "Día",
        "4day": "4 Dias",
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      usuario_log: "",
      events: [],
      rules: {
        required: (value) => !!value || "Este campo es requerido",
      },
    };
  },
  watch: {
    // Watcher para manejo automático de fecha de desatraque cuando se marca el checkbox
    huboDesatraque(val) {
      if (val) {
        // Si hay desatraque y ya hay fecha, auto-asigna hora 08:00
        // if (this.fecha) {
        //   this.desatraque = `${this.fecha}T08:00`;
        // }
      } else {
        // Si se desmarca, limpia el campo desatraque
        this.desatraque = "";
      }
    },
    atraque(newVal) {
      if(newVal ){
        this.huboDesatraque = true;
      }
    },
    solicitud(newVal) {
      if(newVal){
        this.huboDesatraque = false;
        this.fecha = "";
        this.desatraque = "";
      }
    },
    // Watcher para sincronizar fecha con desatraque automáticamente
    fecha(newVal) {
      if(new Date().toISOString().split("T")[0] === newVal){
        this.huboDesatraque = true;
      }else{
        this.huboDesatraque = false;
      }
      // if (newVal) {
      //   // Auto-asigna desatraque con hora por defecto cuando cambia la fecha
      //   this.desatraque = `${newVal}T08:00`;
      // }
    },
    page() {
      this.listar();
    },
    limit() {
      this.page = 1;
      this.listar();
    },
  },

  computed: {
    // Calcula el número total de páginas para la paginación con fallback
    totalPages() {
      // Prioriza el valor de páginas totales del API si está disponible
      const apiPages = Number(this.totalPagesApi) || 0;
      if (apiPages > 0) return apiPages;

      // Fallback: calcula páginas basado en total de registros y límite por página
      const t = Number(this.total) || 0;
      const l = Number(this.limit) || 1;
      const pages = Math.ceil(t / l);
      return pages > 0 ? pages : 1; // Mínimo 1 página
    },
  },
  // Inicialización del componente: carga datos necesarios para el funcionamiento
  created() {
    this.obtenerFoliosSolicitud(); // Carga solicitudes disponibles para el dropdown
    this.listar(); // Carga registros de bitácora con paginación
    this.mostrarEmbarcaciones(); // Carga lista de embarcaciones para filtros
    this.mostrarAgencias(); // Carga lista de agencias para filtros
    this.usuario_log = this.$store.state.usuario; // Obtiene usuario logueado del store
  },
  methods: {
    abrirDetalle(item) {
      this.detalleBitacora = item;
      this.showDetalleDialog = true;
    },
    // Elimina un filtro aplicado y actualiza la lista
    eliminarFiltro(index) {
      this.arr.splice(index, 1); // Remueve filtro del array de filtros activos
      this.page = 1; // Regresa a la primera página
      this.listar(); // Recarga datos sin el filtro eliminado
    },

    // Obtiene y muestra los eventos del calendario basados en la solicitud seleccionada
    mostrarSolicitudFolio() {
      listAccesoFolio(this.solicitud)
        .then((e) => {
          // Actualiza eventos del calendario con los datos de acceso del folio
          this.$set(this, "events", e);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // Carga lista de embarcaciones para el sistema de filtros
    mostrarEmbarcaciones() {
      listEmbarcacionesBitacora()
        .then((e) => {
          // Usa $set para asegurar reactividad en Vue 2
          this.$set(this, "embarcaciones", e);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // Carga lista de agencias para el sistema de filtros
    mostrarAgencias() {
      listAgenciasBitacora()
        .then((e) => {
          // Usa $set para asegurar reactividad en Vue 2
          this.$set(this, "agencias", e);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // Lista los registros de bitácora con paginación y filtros aplicados
    listar() {
      listBitacora(this.limit, this.page, this.arr)
        .then((res) => {
          this.bitacora = res.data; // Datos de bitácora para la tabla
          const meta = res.meta || {};
          // Actualiza metadatos de paginación si están disponibles
          if (typeof meta.total === "number") this.total = meta.total;
          if (typeof meta.totalPages === "number") this.totalPagesApi = meta.totalPages;
          // Ajusta página actual si excede el total (por filtros aplicados)
          if (this.page > this.totalPages) this.page = this.totalPages;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // Obtiene las solicitudes de acceso disponibles para registrar bitácora
    obtenerFoliosSolicitud() {
      this.loading = true;
      getFoliosSolicitudes()
        .then((e) => {
          this.solicitudes = e; // Carga opciones del dropdown de solicitudes
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Inserta un nuevo registro de bitácora con validación de fechas y datos operacionales
    insertarBitacora() {
      this.loading = true;
      let fecha = "";

      // Lógica de manejo de fechas: prioriza fecha simple con hora UTC ajustada
      if (this.fecha) {
        const dateInput = new Date(this.fecha);
        dateInput.setUTCHours(6); // Ajuste de zona horaria
        fecha = dateInput.toISOString();
      } else {
        fecha = this.atraque; // Usa fecha/hora específica de atraque
      }

      // Construye payload con todos los datos operacionales de la embarcación
      const datos = {
        folio_solicitud: this.solicitud,
        atraque: fecha,
        desatraque: new Date(this.desatraque),
        embarque_px: this.embarque_pax, // Pasajeros embarcados
        desembarque_px: this.desembarque_pax, // Pasajeros desembarcados
        embarque_mat: this.embarque_mat, // Material embarcado
        desembarque_mat: this.desembarque_mat, // Material desembarcado
        atraque_desatraque: this.atraq_desat, // Servicios de amarre/desamarre
        movimiento_interno: this.movimient_int, // Movimientos internos en muelle
      };

      insertBitacoraEmbarcacion(datos)
        .then(() => {
          // Notificación de éxito y limpieza de formulario
          this.$notify({
            title: "¡Éxito!",
            text: "La operación se completo con éxito",
            type: "success",
          });
          // Resetea campos del formulario
          this.atraque = "";
          this.fecha = "";
          this.desatraque = "";
          // Actualiza datos dependientes
          this.mostrarSolicitudFolio();
          this.mostrarEmbarcaciones();
          this.mostrarAgencias();
          this.listar();
        })
        .catch((err) => {
          // Manejo de errores específicos del negocio
          this.$notify({
            title: "Error",
            text:
              "Hay fechas pendientes de caputura o estás intentando registrar un atraque en una fecha que ya tiene un atraque y desatraque registrado.",
            type: "error",
          });
          this.fecha = ""; // Solo limpia fecha en error
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Actualiza un registro existente de bitácora con la misma lógica de validación que insertar
    updateBitacora() {
      this.loading = true;
      let fecha = "";

      // Misma lógica de manejo de fechas que insertarBitacora
      if (this.fecha) {
        const dateInput = new Date(this.fecha);
        dateInput.setUTCHours(6); // Ajuste de zona horaria
        fecha = dateInput.toISOString();
      } else {
        fecha = this.atraque;
      }

      // Payload de actualización incluyendo ID del registro
      const datos = {
        _id: this._id, // ID del registro a actualizar
        folio_solicitud: this.solicitud,
        atraque: fecha,
        desatraque: new Date(this.desatraque),
        embarque_px: this.embarque_pax,
        desembarque_px: this.desembarque_pax,
        embarque_mat: this.embarque_mat,
        desembarque_mat: this.desembarque_mat,
        atraque_desatraque: this.atraq_desat,
        movimiento_interno: this.movimient_int,
      };

      updateBitacoraEmbarcacion(datos)
        .then(() => {
          // Éxito en actualización
          this.$notify({
            title: "¡Éxito!",
            text: "La operación se completo con éxito",
            type: "success",
          });
          // Resetea formulario
          this.atraque = "";
          this.fecha = "";
          this.desatraque = "";
          // Actualiza vistas dependientes
          this.mostrarSolicitudFolio();
          this.listar();
        })
        .catch((err) => {
          // Manejo de errores de negocio
          this.$notify({
            title: "Error",
            text:
              "Esto puede deberse a que hay fechas pendientes de caputura o a que estás intentando registrar un atraque en una fecha que ya tiene un atraque registrado.",
            type: "error",
          });
          this.fecha = "";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Sistema de filtros dinámicos que maneja múltiples tipos de filtros con reemplazo automático
    filtroLabelPush(tipo) {
      if (tipo == "folio") {
        // Busca y reemplaza filtro existente de folio
        let existe = this.arr.findIndex((e) => e.field == "folio");
        if (existe >= 0) {
          this.arr.splice(existe, 1); // Elimina filtro anterior
        }
        // Agrega nuevo filtro de folio
        this.arr.push({
          field: "folio_falla",
          value: this.folio_filter,
          label: "Folio : " + this.folio_filter,
          collection: "rf",
        });
      } else if (tipo == "embarcacion") {
        // Manejo de filtro de embarcación con reemplazo
        let existe = this.arr.findIndex((e) => e.field == "embarcacion");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "embarcacion",
          value: this.embarcacion_filter.value,
          label: "Embarcación: " + this.embarcacion_filter.text,
          collection: "embarcacion",
        });
      } else if (tipo == "agencia") {
        // Manejo de filtro de agencia con reemplazo
        let existe = this.arr.findIndex((e) => e.field == "agencia");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "agencia",
          value: this.agencia_filter.value,
          label: "Agencia: " + this.agencia_filter.text,
          collection: "agencia",
        });
      }
      // Cierra diálogos de filtro y reinicia paginación
      this.showFilterEmbarcacion = false;
      this.showFilterAgencia = false;
      this.page = 1; // Regresa a primera página con nuevo filtro
      this.listar(); // Aplica filtros
    },
    // Navegación del calendario: regresa a la fecha actual
    setToday() {
      this.focus = ""; // Vacío regresa al día actual
    },
    // Navegación del calendario: mes/semana anterior
    prev() {
      this.$refs.calendar.prev();
    },
    // Navegación del calendario: mes/semana siguiente
    next() {
      this.$refs.calendar.next();
    },
    // Obtiene color del evento para el calendario
    getEventColor(event) {
      return event.color; // Color asociado al tipo de evento
    },
    // Cambia vista del calendario al día seleccionado
    viewDay({ date }) {
      this.focus = date; // Enfoca fecha seleccionada
      this.type = "day"; // Cambia a vista diaria
    },

    // updateRange({ start, end }) {
    //   const events = [];

    //   const min = new Date();
    //   const max = new Date();

    //   events.push({
    //     name: "Arrow 1 - SU-12",
    //     start: min,
    //     end: max,
    //     color: "orange",
    //     detail: "Solicitud de acceso 2 pasajeros ",
    //     //timed: !allDay,
    //   });

    //   this.events = events;
    // },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    // Inicia modo de edición cargando datos del evento seleccionado con lógica específica para primer atraque
    iniciarEdicion(event) {
      this.editMode = true;
      // Carga datos operacionales del evento seleccionado
      this.embarque_pax = event.data.embarque_px;
      this.desembarque_pax = event.data.desembarque_px;
      this.embarque_mat = event.data.embarque_mat;
      this.desembarque_mat = event.data.desembarque_mat;
      this.atraq_desat = event.data.atraque_desatraque;
      this.movimient_int = event.data.movimiento_interno;
      this._id = event.data._id;

      // Determina si es el primer atraque para manejar formato de fecha diferente
      const index = this.events.findIndex((e) => e.data._id == event.data._id);
      this._id = event.data._id;

      if (index === 0) {
        // Primer atraque: usa datetime-local con hora específica
        this.primer_atraque = true;
        console.log(event.data.atraque);
        const fecha = new Date(event.data.atraque);

        // Convierte a formato yyyy-MM-ddThh:mm para datetime-local input
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, "0");
        const day = String(fecha.getDate()).padStart(2, "0");
        const hours = String(fecha.getHours()).padStart(2, "0");
        const minutes = String(fecha.getMinutes()).padStart(2, "0");

        this.atraque = `${year}-${month}-${day}T${hours}:${minutes}`;
        console.log(this.atraque);
      } else {
        // Atraques subsecuentes: usa solo fecha (date input)
        this.primer_atraque = false;
        const fechaISO = event.data.atraque;
        this.fecha = new Date(fechaISO).toISOString().split("T")[0];
      }

      // Manejo del desatraque si existe
      if (event.data.desatraque) {
        this.huboDesatraque = true;
        const fecha = new Date(event.data.desatraque);

        // Convierte desatraque a formato datetime-local
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, "0");
        const day = String(fecha.getDate()).padStart(2, "0");
        const hours = String(fecha.getHours()).padStart(2, "0");
        const minutes = String(fecha.getMinutes()).padStart(2, "0");

        this.desatraque = `${year}-${month}-${day}T${hours}:${minutes}`;
      } else {
        // Sin desatraque registrado
        this.huboDesatraque = false;
        this.desatraque = "";
      }
    },

    // Inicia proceso de confirmación de eliminación
    confirmDelete(item) {
      this.itemToDelete = item; // Guarda referencia del item a eliminar
      this.dialogDelete = true; // Muestra diálogo de confirmación
    },

    // Ejecuta la eliminación del registro de bitácora
    deleteItemConfirm() {
      this.loading = true;
      deleteBitacoraEmbarcacion(this.itemToDelete.data._id)
        .then(() => {
          // Notificación de éxito
          this.$notify({
            title: "¡Éxito!",
            text: "Registro eliminado correctamente.",
            type: "success",
          });
          this.closeDelete(); // Cierra diálogo
          // Actualiza datos dependientes
          this.mostrarSolicitudFolio(); // Actualiza calendario
          this.listar(); // Actualiza tabla
        })
        .catch((err) => {
          console.log(err);
          // Notificación de error
          this.$notify({
            title: "Error",
            text: "No se pudo eliminar el registro.",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Cierra diálogo de eliminación y limpia referencias
    closeDelete() {
      this.dialogDelete = false;
      this.itemToDelete = null; // Limpia referencia
      this.selectedOpen = false; // Cierra modal de evento
    },

    // Cancela modo de edición y resetea todos los campos del formulario
    cancelarEdicion() {
      this.editMode = false; // Desactiva modo edición
      // Resetea campos de fechas
      this.atraque = null;
      this.fecha = null;
      this.desatraque = null;
      // Resetea campos numéricos a valores por defecto
      this.embarque_pax = 0;
      this.desembarque_pax = 0;
      this.embarque_mat = 0;
      this.desembarque_mat = 0;
      // Resetea campos booleanos
      this.atraq_desat = false;
      this.movimient_int = 0;
      this.huboDesatraque = false;
    },

    // Formatea valores monetarios con localización mexicana
    formatCurrency(value) {
      if (!value) return "0.00";
      return new Intl.NumberFormat("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    // Formatea fechas con localización mexicana y manejo de errores robusto
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        if (isNaN(d.getTime())) return String(value); // Fallback si fecha es inválida
        return d.toLocaleString("es-MX", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false, // Formato 24 horas
        });
      } catch (e) {
        return String(value); // Fallback en caso de excepción
      }
    },

    formatFolio(folio, muelle, created) {
      // Formateo básico: padding con ceros a 4 dígitos
      const folio_number = folio.toString().padStart(4, "0");
      const date = new Date(created);
      // Extracción de componentes de fecha en formato UTC
      const day = date.getUTCDate().toString().padStart(2, "0");
      const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
      const year = date.getUTCFullYear();

      // Lógica de negocio: clasificación geográfica de muelles
      let muelle_folio = "";
      // Muelles de zona Chiltepec
      if (
        muelle == "CHILTEPEC" ||
        muelle == "MUELLE DE TANQUES" ||
        muelle == "MUELLE PESCADORES CHILTEPEC"
      ) {
        muelle_folio = "CH";
      } else {
        // Muelles de zona Frontera (por defecto)
        muelle_folio = "FR";
      }

      // Sistema de codificación por tipo de muelle (normativa APITAB)
      let clave_muelle = "";
      switch (muelle) {
        case "ESPADAÑAL":
          clave_muelle = "PAR"; // Particular
          break;
        case "CENTRO DE REPARACIONES NAVALES":
          clave_muelle = "PAR";
          break;
        case "MUELLE PESCADORES FRONTERA":
          clave_muelle = "DEP";
          break;
        case "MUELLE FISCAL":
          clave_muelle = "FIS";
          break;
        case "PARTICULAR":
          clave_muelle = "PAR";
          break;
        case "MUELLE DE TANQUES":
          clave_muelle = "PAR";
          break;
        case "MUELLE PESCADORES CHILTEPEC":
          clave_muelle = "PES";
          break;
        case "SANCHEZ MAGALLANES":
          clave_muelle = "PAR";
          break;
        case "MUELLE COSUGO":
          clave_muelle = "PAR";
          break;
        case "MUELLE PRIVADO CARLOS DAVID":
          clave_muelle = "PAR";
          break;
      }

      // Regla de negocio especial: folios <= 75 usan formato simplificado
      if (folio <= 75) {
        return folio_number;
      }

      // Formato completo para folios > 75: ajuste numérico y codificación completa
      let otro_folio = folio_number - 75;
      const folio_number_2 = otro_folio.toString().padStart(4, "0");
      // Formato final: FOLIO/ZONA/TIPO/FECHA
      return `${folio_number_2}/${muelle_folio}/${clave_muelle}/${day}${month}${year}`;
    },

    // Maneja la apertura/cierre de modales de eventos del calendario con animaciones suaves
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event; // Evento seleccionado para mostrar detalles
        this.selectedElement = nativeEvent.target; // Elemento DOM de referencia para posicionamiento
        // Doble requestAnimationFrame para asegurar renderizado suave
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      // Si ya hay un modal abierto, ciérralo primero antes de abrir el nuevo
      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation(); // Previene propagación de eventos
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@400;700&display=swap");

.texto {
  font-family: "Raleway", sans-serif;
}

.v-data-table >>> .v-data-table-header {
  background-color: rgb(128, 0, 32) !important;
}

.input-filter {
  background-color: rgb(241, 241, 241);
  border-radius: 5px;
  padding: -5px;
  width: 50%;
  height: 40px;
}

.input-filter_seguimiento {
  background-color: rgb(226, 226, 226);
  border-radius: 5px;
  padding: -45px;
  width: 100%;
  height: 25px;
}

.input-filter_title {
  background-color: rgb(29, 29, 29);
  border-radius: 20px;
  padding: -45px;
  color: white;
  width: 100%;
  text-align: center;
  height: 25px;
}

.button-fab {
  bottom: 50px;
  height: 60px;
  position: fixed;
  right: 20px;
  width: 60px;
}

.filter-label {
  color: #b1adad;
  margin-top: -35px;
  margin-left: 40px;
  font-size: 13px;
  font-weight: normal;
}

.filter-chips {
  color: #b1adad;
  padding: -10px;
  margin-top: -41px;
  margin-left: 40px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.v-input--select .v-label {
  font-size: 2px;
}

/* Borde redondeado para v-simple-table */
.rounded-table {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden; /* recorta el header de color dentro del radio */
  border-collapse: separate;
  border-spacing: 0;
}

.rounded-table thead {
  /* asegura que el fondo del thead se recorte por el overflow */
  clip-path: inset(0 round 12px 12px 0 0);
}

/* Row click affordance */
.clickable-row {
  cursor: pointer;
}
.clickable-row:hover td {
  background-color: #f5f5f5;
}
</style>
